import { PropTypes } from "prop-types";
import { withERPSTabValidator } from "../../hoc/withERPSTabValidator";
import { ResponsiveBox, Typography } from "../../primitives";

function TabPanel(props) {
  const { children, value, index, tabId, ...other } = props;
  return (
    <ResponsiveBox
      role="tabpanel"
      hidden={value !== index}
      id={tabId || `user-tabpanel-${index}`}
      {...other}
    >
      {value === index && (
        <ResponsiveBox sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </ResponsiveBox>
      )}
    </ResponsiveBox>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default withERPSTabValidator(TabPanel);
